import { _useMiniCardHook } from 'generic/MiniCard2/MiniCardContext';

export default _useMiniCardHook;
